/* eslint-disable import/prefer-default-export */
import { api, secureCall } from 'utils/api';

const route = 'hr-process';

export const getHrProcess = secureCall((params) => api.get(route, { params }));
